//info
export const SET_INFO = 'SET_INFO'
export const SET_LANGUAGE = 'SET_LANGUAGE'

//portal
export const SET_PORTAL = 'SET_PORTAL'
export const CHANGE_PORTAL = 'CHANGE_PORTAL'
export const COPY_CONTENT_FROM_LANGUAGE = 'COPY_CONTENT_FROM_LANGUAGE'

//profile image
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE'
export const SET_PROFILE_IMAGE_ERROR = 'SET_PROFILE_IMAGE_ERROR'
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE'
export const UPDATE_PROFILE_IMAGE_ERROR = 'UPDATE_PROFILE_IMAGE_ERROR'
export const REMOVE_PROFILE_IMAGE = 'REMOVE_PROFILE_IMAGE'
export const REMOVE_PROFILE_IMAGE_ERROR = 'REMOVE_PROFILE_IMAGE_ERROR'

//gallery images
export const ADD_GALLERY_IMAGE = 'ADD_GALLERY_IMAGE'
export const ADD_GALLERY_IMAGE_ERROR = 'ADD_GALLERY_IMAGE_ERROR'
export const UPDATE_GALLERY_IMAGE = 'UPDATE_GALLERY_IMAGE'
export const UPDATE_GALLERY_IMAGE_ERROR = 'UPDATE_GALLERY_IMAGE_ERROR'
export const UPDATE_GALLERY_IMAGES = 'UPDATE_GALLERY_IMAGES'
export const UPDATE_GALLERY_IMAGES_ERROR = 'UPDATE_GALLERY_IMAGES_ERROR'
export const REMOVE_GALLERY_IMAGE = 'REMOVE_GALLERY_IMAGE'
export const REMOVE_GALLERY_IMAGE_ERROR = 'REMOVE_GALLERY_IMAGE_ERROR'

//link
export const ADD_LINK_IMAGE = 'ADD_LINK_IMAGE'
export const ADD_LINK_IMAGE_ERROR = 'ADD_LINK_IMAGE_ERROR'
export const UPDATE_LINK_IMAGE = 'UPDATE_LINK_IMAGE'
export const UPDATE_LINK_IMAGE_ERROR = 'UPDATE_LINK_IMAGE_ERROR'
export const UPDATE_LINK_IMAGES = 'UPDATE_LINK_IMAGES'
export const UPDATE_LINK_IMAGES_ERROR = 'UPDATE_LINK_IMAGES_ERROR'
export const REMOVE_LINK_IMAGE = 'REMOVE_LINK_IMAGE'
export const REMOVE_LINK_IMAGE_ERROR = 'REMOVE_LINK_IMAGE_ERROR'

//listing
export const INIT_LISTING = 'INIT_LISTING'
export const SET_LISTING = 'SET_LISTING'
export const CHANGE_LISTING = 'CHANGE_LISTING'
export const ADD_LISTING_IMAGE = 'ADD_LISTING_IMAGE'
export const ADD_LISTING_IMAGE_ERROR = 'ADD_LISTING_IMAGE_ERROR'
export const UPDATE_LISTING_IMAGE = 'UPDATE_LISTING_IMAGE'
export const UPDATE_LISTING_IMAGE_ERROR = 'UPDATE_LISTING_IMAGE_ERROR'
export const ADD_LISTING_PORTAL = 'ADD_LISTING_PORTAL'

//banner
export const INIT_BANNERS = 'INIT_BANNERS'
export const SET_BANNERS = 'SET_BANNERS'
export const CHANGE_BANNER = 'CHANGE_BANNER'
export const UPDATE_BANNER_ITEM = 'UPDATE_BANNER_ITEM'
export const ADD_BANNER_ITEM = 'ADD_BANNER_ITEM'
export const ADD_BANNER_ITEM_ERROR = 'ADD_BANNER_ITEM'
export const REMOVE_BANNER_ITEM = 'REMOVE_BANNER_ITEM'
export const REMOVE_BANNER_ITEM_ERROR = 'REMOVE_BANNER_ITEM_ERROR'
export const ADD_BANNER_IMAGE_ITEM = 'ADD_BANNER_IMAGE_ITEM'
export const ADD_BANNER_IMAGE_ITEM_ERROR = 'ADD_BANNER_IMAGE_ITEM_ERROR'
export const UPDATE_BANNER_IMAGE_ITEM = 'UPDATE_BANNER_IMAGE_ITEM'
export const UPDATE_BANNER_IMAGE_ITEM_ERROR = 'UPDATE_BANNER_IMAGE_ITEM_ERROR'
export const REMOVE_BANNER_IMAGE_ITEM = 'REMOVE_BANNER_IMAGE_ITEM'
export const CREATE_BANNER_ITEM = 'CREATE_BANNER_ITEM'

//town
export const SET_TOWN = 'SET_TOWN'
export const INIT_TOWN = 'INIT_TOWN'
export const INIT_TOWN_ERROR = 'INIT_TOWN_ERROR'
export const NOT_FOUND_TOWN = 'NOT_FOUND_TOWN'

//contributor
export const SET_CONTRIBUTOR = 'SET_CONTRIBUTOR'
export const UPDATE_CONTRIBUTOR_IMAGE = 'UPDATE_CONTRIBUTOR_IMAGE'
export const UPDATE_CONTRIBUTOR_IMAGE_ERROR = 'UPDATE_CONTRIBUTOR_IMAGE_ERROR'
export const ADD_CONTRIBUTOR_IMAGE_ERROR = 'ADD_CONTRIBUTOR_IMAGE_ERROR'
export const ADD_CONTRIBUTOR_IMAGE = 'ADD_CONTRIBUTOR_IMAGE'



// WEBPACK FOOTER //
// ./src/constants/actions.js